window._ = require('lodash')
window.$ = require('jquery')
window.Vue = require('vue')
window.Cookies = require('js-cookie')

window.axios = require('axios')
window.axios.defaults.baseURL = '/'

let csrf = document.head.querySelector('meta[name="csrf-token"]')
let utoken = Cookies.get('utoken')
if (utoken) {
  utoken = JSON.parse(utoken)
}

const authConfig = {
  'X-CSRF-TOKEN': csrf.content,
  'X-Requested-With': 'XMLHttpRequest'
}

if (_.isObject(utoken)) {
  authConfig['Authorization'] = 'Bearer ' + utoken.token
}

window.axios.defaults.headers.common = authConfig
